import { pages } from '@constants/pages';
import { Link } from 'react-router';

function NotFound() {
  return (
    <div className="flex h-[calc(100vh-5.7rem)] w-full flex-col items-center justify-center">
      <h2 className="text-gray500 mb-4 text-[3rem] font-black">Erro 404</h2>
      <p className="text-gray200 mb-8 text-[1.15rem]">
        Está página não existe ou não foi encontrada, por favor retorne a página
        inicial.
      </p>
      <Link
        className="bg-orange700 text-white900 flex h-[2.25rem] w-[15rem] items-center justify-center rounded-md border-0 hover:opacity-75"
        replace
        to={pages.auth.signIn}>
        Ir para o inicio
      </Link>
    </div>
  );
}

export default NotFound;
